import { Box, Flex, Input, Text } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '@shared';
import SuperadminUserDrawer from '../users/SuperadminUserDrawer';

export default function AccountUsersList({ users: accountUsers, userAccounts }: { users: User[]; userAccounts: UserAccount[] }) {
	const { t } = useTranslation();
	const [search, setSearch] = useState('');
	const { openDrawer } = useDrawer();

	const users = useMemo(() => {
		const query = search.trim().toLowerCase();

		return accountUsers
			.map(user => ({
				...user,
				isAdmin: userAccounts.find(userAccount => userAccount.userID === user.userID)?.userAccountRole === 'admin',
				fullName: `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
			}))
			.filter(user => !query || [user.fullName, user.email, user.phone].some(value => value?.toLowerCase().includes(query)))
			.sort((a, b) => Number(b.isAdmin) - Number(a.isAdmin) || a.fullName.localeCompare(b.fullName));
	}, [accountUsers, userAccounts, search]);

	return (
		<Flex flexDirection={'column'} gap={4} marginBottom={3} width={'100%'}>
			<Input placeholder={t('general.search')} value={search} onChange={e => setSearch(e.target.value)} />
			<Flex flexDirection={'column'} gap={4} maxHeight={'400px'} overflowY={'auto'}>
				{users.length ? (
					users.map(user => (
						<Box
							key={user.userID}
							cursor={'pointer'}
							onClick={() => openDrawer({ id: 'userDrawer', content: <SuperadminUserDrawer userID={user.userID} /> })}
						>
							<Text fontWeight="semibold" color="gray.700">
								{user.fullName || '-'}
								{user.isAdmin ? ` (${t('general.admin')})` : ''}
							</Text>
							<Text userSelect="text" color="gray.600">
								{user.email || '-'}
							</Text>
							<Text userSelect="text" color="gray.600">
								{user.phone || '-'}
							</Text>
						</Box>
					))
				) : (
					<Text color="gray.600">{search.trim() ? `${t('general.no_search_results_with')} "${search.trim()}"` : t('general.no_data')}</Text>
				)}
			</Flex>
		</Flex>
	);
}
